// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csD8p{font-family:"Inter",sans-serif;border:2px solid rgba(0,0,0,0);border-radius:.9375rem;background-color:#0078d4;color:#fff;font-size:15px;font-weight:600;padding:13px 25px;cursor:pointer;text-transform:none;min-width:220px}
.dYqd3{font-family:"Inter",sans-serif}
.EbdcG{background-color:#fff;border-radius:16px 16px 0 0;font-family:"Inter",sans-serif;top:-8px;position:relative;padding-top:48px;padding-bottom:24px;-webkit-box-shadow:0 -4px 20px -4px rgba(0,0,0,.04);box-shadow:0 -4px 20px -4px rgba(0,0,0,.04)}
.tsq8Z{font-weight:700;font-size:28px;color:#0f172a;letter-spacing:-0.5px;line-height:1.3;margin-bottom:0}
.LZAvl{margin-top:12px;font-weight:400;font-size:16px;color:#64748b;letter-spacing:-0.1px;line-height:1.6;margin-left:auto;margin-right:auto}
.mItCe{font-family:"Inter",sans-serif;color:#1e293b;font-size:18px;font-weight:500;text-align:center;opacity:.7;letter-spacing:-0.2px;line-height:150%;margin-top:15px}
.Kmh0n{color:#0078d4;text-decoration:none;cursor:pointer}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonBlue": `csD8p`,
	"baseContainer": `dYqd3`,
	"formContainer": `EbdcG`,
	"title": `tsq8Z`,
	"subtitle": `LZAvl`,
	"needHelpText": `mItCe`,
	"needHelpLink": `Kmh0n`
};
module.exports = ___CSS_LOADER_EXPORT___;
